"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Breadcrumb_1 = __importDefault(require("../Breadcrumb"));
function Page({ route }) {
    const PageBody = route.Component;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        route.parent && react_1.default.createElement(Breadcrumb_1.default, { route: route }),
        react_1.default.createElement(PageBody, null)));
}
exports.default = Page;
